import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actionCreators/auth';
import { addAlertToAlertsList } from '../../actionCreators/globalAlerts';

import PrivacyAndTermsComponent from '../../components/PrivacyAndTerms';

const PrivacyAndTerms = (props) => {
  const account = useSelector((state) => state.account);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const addAlert = (payload) => {
    dispatch(addAlertToAlertsList(payload));
  };

  return (
    <PrivacyAndTermsComponent
      {...props}
      account={account}
      handleLogout={handleLogout}
      addAlertToAlertsList={addAlert}
    />
  );
};

export default PrivacyAndTerms;